import { BANKS_WITH_SECONDARY_LANGUAGE } from "@portal/assets/banks";

export const IsBankNewNorwegian = (centerId: string | null) => {
  if (!centerId) return false;

  return BANKS_WITH_SECONDARY_LANGUAGE.some(bankCenterId => bankCenterId === centerId);
};
